import {atom, useSetRecoilState} from 'recoil';
import {ReactNode} from "react";


export const providerState = atom<string>({
    key: 'Provider',
    default: ''
})

export const nameState = atom<string>({
    key: 'nameState',
    default: ''
})

export const birthdateState = atom<string>({
    key: 'birthdateState',
    default: ''
})

export const phoneNumberState = atom<string>({
    key: 'phoneNumberState',
    default: ''
})

interface popupStateProps {
    children?: ReactNode;
    confirm?: Function;
}

export const popupState = atom<popupStateProps>({
    key: "popupState",
    default: {}
})

export const popupShowState = atom<boolean>({
    key: "popupShowState",
    default: false
})

export const usePopup = () => {
    const setPopup = useSetRecoilState(popupState);
    const showPopup = useSetRecoilState(popupShowState);

    return (children?: ReactNode, confirm?: Function) => {
        setPopup({children, confirm})
        showPopup(true);
    };
}